import crud from './helpers/crud';

const getNotifications = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_NOTIFICATIONS',
      fail: 'FAILED_GET_NOTIFICATIONS',
      end: 'FINISHED_GET_NOTIFICATIONS',
    },
    method: 'GET',
    url: '/api/v1/notifications',
  })
);

const dismissNotification = (notificationId) => async (dispatch) => {
  const result = await dispatch(crud({
    dispatch: {
      begin: 'BEGIN_DISMISS_NOTIFICATION',
      fail: 'FAILED_DISMISS_NOTIFICATION',
      end: 'FINISHED_DISMISS_NOTIFICATION',
    },
    method: 'DELETE',
    url: `/api/v1/notifications/${encodeURIComponent(notificationId)}`,
  }));

  if (!result?.error && !result?.canceled) dispatch(getNotifications());
  return result;
};

export {
  dismissNotification,
  getNotifications,
};
